export const forEachDocs = {
  name: 'forEach',
  category: 'Matrix',
  syntax: [
    'forEach(x, callback)'
  ],
  description: 'Iterates over all elements of a matrix/array, and executes the given callback function.',
  examples: [],
  seealso: ['map', 'sort', 'filter']
}
